import lengthEndAdornment from "constants/lenghtEndAdornment";
import CreateProductAttributesFormFields from "./CreateProductAttributesFormFields";

const fields = [
  {
    name: "applicationRate",
    label: "Concrete Depth",
    inputProps: { ...lengthEndAdornment },
  },
];

export default function ConcreteFlatworkForm() {
  return <CreateProductAttributesFormFields fields={fields} />;
}
